import axios from "axios";
import { API } from "../config";

let geoPromise = null;
// Una sola consulta /geo por sesión de página, compartida por el chip y el banner de aeropuerto
export const fetchGeo = () => {
  if (!geoPromise) geoPromise = axios.get(`${API}/geo`).then(r => r.data).catch(() => null);
  return geoPromise;
};

export const browserIsSpanish = () => {
  try { return (navigator.language || "es").toLowerCase().startsWith("es"); } catch { return true; }
};

// Turista probable: cerca de un aeropuerto canario, IP extranjera o navegador en otro idioma
export const touristContext = (geo) => {
  if (!geo?.ok) return browserIsSpanish() ? null : { reason: "lang" };
  if (geo.airport) return { reason: "airport", airport: geo.airport };
  if (geo.is_spain === false) return { reason: "foreign", country: geo.country };
  if (!browserIsSpanish()) return { reason: "lang" };
  return null;
};
